import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Landmark } from "lucide-react";
import { Link } from "react-router-dom";

export default function Header({ onCtaClick }) {
  const [open, setOpen] = useState(false);

  const links = [
    { href: "/servicios", label: "Servicios" },
    { href: "/como-funciona", label: "Cómo funciona" },
    { href: "/empresas", label: "Empresas" },
    { href: "/nosotros", label: "Nosotros" },
    { href: "/evaluacion", label: "Evaluación" },
  ];

  return (
    <header
      className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <div className="h-9 w-9 rounded-lg bg-blue-600 text-white flex items-center justify-center">
            <Landmark className="h-5 w-5" strokeWidth={2} />
          </div>
          <span className="font-extrabold text-lg tracking-tight text-slate-900">
            Bancoorp
          </span>
          <span className="hidden sm:inline text-xs text-slate-500 border-l border-slate-200 pl-2 ml-1">
            Intermediario de créditos
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
              data-testid={`nav-${l.href.replace("/", "")}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            onClick={onCtaClick}
            className="hidden sm:inline-flex bg-blue-600 hover:bg-blue-700 text-white rounded-full px-5"
            data-testid="header-cta-button"
          >
            Comparar créditos
          </Button>
          <button
            className="md:hidden p-2 rounded-lg hover:bg-slate-100"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-slate-700 py-2"
              >
                {l.label}
              </Link>
            ))}
            <Button
              onClick={() => {
                setOpen(false);
                onCtaClick();
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-full"
              data-testid="mobile-cta-button"
            >
              Comparar créditos
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
